

















































import {
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BEmbed,
    BForm,
    BFormCheckbox,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BLink,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import { computed, defineComponent, onMounted, PropType, ref, watch } from "@vue/composition-api";
// @ts-ignore
import i18n from "@/libs/i18n";
import { TemplateInterface } from "@/interfaces/template.interface";
import useFileUploads from "@/composables/useFileUploads";
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import axios from "@/libs/axios";
import { getFullPath } from "@/utils/assets";
import { resolveContentTypeIcon } from "@/utils/chats";
import { MediaTypeType } from "@/types/mediaType.type";
import useAssets from "@/composables/useAssets";
import { AssetInterface } from "@/interfaces/asset.interface";

export default defineComponent({
    components: {
        BLink,
        BEmbed,
        BButton,
        BForm,
        BFormSelect,
        BFormInput,
        BFormGroup,
        BCard,
        BCardTitle,
        BCardText,
        BFormTextarea,
        BFormFile,
        BFormCheckbox,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        value: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },
    setup(props, { emit }) {
        const toast = useToast();
        const { uploadFile, clearFiles, getAllowedFileTypes } = useFileUploads();
        const { retrieveAsset, getAsset, setAsset } = useAssets();

        const template = computed<TemplateInterface>({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        const isAssetLocked = computed<boolean>({
            get: (): boolean => props.value.assetIsLocked === 1,
            set: (value: boolean): void => {
                props.value.assetIsLocked = value ? 1 : 0;
            },
        });

        const asset = computed(() => getAsset(template.value.assetId));

        watch(
            () => template.value.assetId,
            () => {
                if (template.value.assetId) {
                    retrieveAsset(template.value.assetId);
                }
            },
            { immediate: true }
        );

        const allowedFileTypes = computed(() =>
            getAllowedFileTypes(template.value.mediaType as MediaTypeType, {
                platform: "whatsapp",
                provider: "messagebird",
            }).join(",")
        );

        const isUploadingAsset = ref(false);
        const uploadAsset = (event: unknown) => {
            isUploadingAsset.value = true;
            clearFiles();

            return uploadFile(event, 16)
                .then((uploadedAsset) => {
                    return axios.post<AssetInterface>(`assets`, uploadedAsset).then(({ data: newAsset }) => {
                        setAsset(newAsset.id, newAsset);
                        template.value.assetId = newAsset.id;
                    });
                })
                .catch((error) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("upload.failed"),
                            text: i18n.t(error.message),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                })
                .finally(() => {
                    isUploadingAsset.value = false;
                });
        };

        const openFilePrompt = () => {
            document.getElementById("file")?.click();
        };

        const removeAsset = () => {
            template.value.assetId = undefined;
        };

        return {
            removeAsset,
            allowedFileTypes,
            uploadAsset,
            getFullPath,
            isUploadingAsset,
            resolveContentTypeIcon,
            asset,
            template,
            openFilePrompt,
            isAssetLocked,
        };
    },
});
